<template>
  <div class="pc-list" ref="list">
    <h2>评论设置</h2>
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <!-- <button @click="deleteDesignerInit">删除</button> -->
          <!-- <span></span> -->
          <button @click="addComment">添加</button>
          <!-- <span></span>
          <button @click="exportDesigner">导出数据</button> -->
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      @sort-change="changeSort"
      :data="designerList"
    >
      <!-- <el-table-column width="100" class="singleCheckStyle" fixed="left">
        <template slot-scope="scope" fixed="left">
          <el-checkbox
            v-model="designerList[scope.$index].isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        fixed="left"
        prop="id"
        label="编号"
        width="100"
      ></el-table-column> -->
      <el-table-column prop="image" label="头像" width="150" fixed="left">
        <template slot-scope="scope">
          <div class="eltable-img">
            <img
              v-if="scope.row.reviewer_profile"
              :src="scope.row.reviewer_profile"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="chinese_name"
        label="姓名"
        width="180"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.reviewer ? scope.row.reviewer : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="chinese_name"
        label="评论"
        width="600"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.content ? scope.row.content : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="180" >
        <template slot-scope="scope" >
            <div style="display:flex">
          <button class="btnViewDetail" @click="viewDetail(scope.row)" style="margin-right:30px">
            修改
          </button>
          <button class="btnViewDetail" @click="deleteDetail(scope.row)">
            删除
          </button>
            </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      class="designerDialog"
      :title="commentDetails.reviewer"
      :visible.sync="isUpdateShow"
      width="30%"
    >
      <el-form label-width="80px">
        <el-form-item label="图片">
          <UploadImage
            :img="commentDetails.reviewer_profile"
            :width="200"
            :height="160"
            @getUploadImage="getUploadImage"
          ></UploadImage>
        </el-form-item>
        <el-form-item label="评论人">
          <el-input v-model="commentDetails.reviewer" placeholder="请输入名称">
          </el-input>
        </el-form-item>
        <el-form-item label="评论">
          <el-input
            type="textarea"
            :rows="2"
            v-model="commentDetails.content"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button-one"
          @click="isUpdateShow = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitBanner(commentDetails)"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <Pagination
      v-if="designerList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
    <!-- @handleCurrentChange="goPage"
      @goLastPage="goPage"
      @goFirstPage="goPage" -->
  </div>
</template>

<script>
import Pagination from "@/components/componentSet/Pagination";
import DeleteHint from "@/components/template/DeleteHint";
import UploadImage from "../../../componentSet/uploadImage.vue";
import {
  getComment_Api,
  createComment_Api,
  updateComment_Api,
  deleteComment_Api,
  //   outputDesigner_Api
} from "@/apis/magazine.api";
export default {
  components: {
    UploadImage,
    Pagination,
    DeleteHint,
  },
  data() {
    return {
      loading: false,
      isUpdateShow: false,
      deleteDialogVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
        article_id: null,
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      // commentDetail: {
      //   reviewer_profile: "",
      //   article_id: null,
      //   comment_id: null,
      // },
      commentDetails: {
        content_id: "",
        reviewer_profile: "",
        content: "",
        reviewer: "",
        content_type:""
      },
      isSelectAll: false,
      designerList: [],
      checked: [],
      delete_ids: null,
    };
  },
  mounted() {
    this.getDesignerListByRules(this.searchRules);
  },
  methods: {
    // 获取
    getDesignerListByRules(data) {
      this.loading = true;
      // this.searchRules.article_id = + this.$route.query.id;
      getComment_Api(this.$route.query.id,this.$route.query.content_type)
        .then((res) => {
          console.log(res.data);
          this.$set(this.pagination_options, "total", res.data.length);
          this.designerList = res.data;
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    // 排序
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getDesignerListByRules(data);
      this.pagination_options.page = 1;
    },
    viewDetail(item) {
      this.isUpdateShow = true;
      this.commentDetails.comment_id = item.id;
      this.commentDetails.reviewer_profile = item.reviewer_profile;
      this.commentDetails.content = item.content;
      this.commentDetails.reviewer = item.reviewer;
    },
    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.getDesignerListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      formData.article_id = formData.article_id;
      return data;
    },
    isDelete() {
      deleteComment_Api({ comment_id: this.delete_ids })
        .then((res) => {
          console.log("删除成功！");
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.getDesignerListByRules();
        })
        .catch((err) => {
          console.log("删除失败！");
        });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    deleteDetail(item) {
      this.delete_ids = item.id;
      this.deleteDialogVisible = true;
    },
    addComment() {
      this.isUpdateShow = true;
      
      for (let key in this.commentDetails) {
        this.commentDetails[key] = null;
      }
    },
    getUploadImage(img_url) {
      this.commentDetails.reviewer_profile = img_url;
    },
    submitBanner(item) {
      this.commentDetails.content_id = +this.$route.query.id;
      this.commentDetails.content_type = this.$route.query.content_type;
      if (this.commentDetails.comment_id == null) {
        createComment_Api(this.commentDetails).then((res) => {
          console.log(res);
          this.getDesignerListByRules();
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      } else {
        updateComment_Api(this.commentDetails).then((res) => {
          this.getDesignerListByRules();
          console.log(res);
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      }
    },


    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getDesignerListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
/deep/ .el-dialog {
  width: 40% !important;
}
/deep/ .el-dialog__footer {
  .dialog-footer-button-one {
    @include manage-button;
    background: $test;
    color: $blueBtna;
  }
  .dialog-footer-button-second {
    @include manage-button;
  }
}
/deep/ .el-upload__tip {
  margin-top: -10px;
}
.pc-list {
  @include table-head;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/guihua/components/Comment.vue